var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArtichautMonogramme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E2C779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C9A961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57A2A"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100 80)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M166 0 84 53 0 342l118-45 73-108 15-189Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gold)",
    d: "M181 0 226 40 312 342l-79-43-72-110-12-150Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAF6EC",
    d: "m120 191 45 37-24 91-71-112Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "m165 228 36-34 35 48-71 77Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtichautMonogramme);
export default __webpack_public_path__ + "static/media/artichaut-monogramme.d9175f472abdb95a6310a63df4a0cd3b.svg";
export { ForwardRef as ReactComponent };